// src/components/mdx/MDXImage.tsx
import GcsImage, { GcsPath } from "../common/GcsImage";

interface MDXImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  caption?: string;
}

function normalizeSrc(src: string): string {
  return src.startsWith("/") ? src.slice(1) : src;
}

export default function MDXImage({
  src,
  alt,
  caption,
}: MDXImageProps) {
  return (
    <span className="block my-8 text-center">
      <GcsImage
        path={normalizeSrc(src) as GcsPath}
        alt={alt}
        className="mx-auto rounded-lg"
      />

      {caption && (
        <span className="mt-2 block text-xs text-gray-500">{caption}</span>
      )}
    </span>
  );
}
